import api from './api';
import { API_ROUTES } from '@/lib/constants';
import type { ApiResponse, DashboardSummary, DealFunnelItem, RevenueChartItem, LeadSourceItem, TasksOverviewItem, Activity, Deal } from '@/types/table';

export const dashboardService = {
  getSummary: async (): Promise<ApiResponse<DashboardSummary>> => {
    const response = await api.get(`${API_ROUTES.DASHBOARD}/summary`);
    return response.data;
  },

  getDealsFunnel: async (pipelineId?: string): Promise<ApiResponse<DealFunnelItem[]>> => {
    const response = await api.get(`${API_ROUTES.DASHBOARD}/deals-funnel`, {
      params: pipelineId ? { pipelineId } : undefined,
    });
    return response.data;
  },

  getRevenueChart: async (params?: Record<string, unknown>): Promise<ApiResponse<RevenueChartItem[]>> => {
    const response = await api.get(`${API_ROUTES.DASHBOARD}/revenue-chart`, { params });
    return response.data;
  },

  getLeadSources: async (): Promise<ApiResponse<LeadSourceItem[]>> => {
    const response = await api.get(`${API_ROUTES.DASHBOARD}/lead-sources`);
    return response.data;
  },

  getTasksOverview: async (): Promise<ApiResponse<TasksOverviewItem[]>> => {
    const response = await api.get(`${API_ROUTES.DASHBOARD}/tasks-overview`);
    return response.data;
  },

  getRecentActivities: async (): Promise<ApiResponse<Activity[]>> => {
    const response = await api.get(`${API_ROUTES.DASHBOARD}/recent-activities`);
    return response.data;
  },

  getTopDeals: async (): Promise<ApiResponse<Deal[]>> => {
    const response = await api.get(`${API_ROUTES.DASHBOARD}/top-deals`);
    return response.data;
  },
};
